import { DictionaryCategory, ExtractCategory, LoadingStatusEnum, DictionaryCategorySchema, ExtractCategorySchema } from "etl/types";
import { createAppAsyncThunk } from "core/src/store/store.types";
import { displayApiErrorToast } from "core/src/slices/ui/useCases/display-api-error-toast/display-api-error-toast.use-case";

export type LoadCategoryRequest = {
	forceReload?: boolean
} | void;

type LoadCategoriesResponse = {
	dictionnaryCategories: DictionaryCategory[];
	extractCategories: ExtractCategory[];
};

export const loadCategories = createAppAsyncThunk<LoadCategoriesResponse, LoadCategoryRequest>(
	"etlData/loadCategories",
	async (_, { extra, rejectWithValue, dispatch, getState }) => {

		const { selectedEtlImportUuid } = getState().etlData;

		if (!selectedEtlImportUuid) {
			return rejectWithValue("No etl import selected");
		}

		try {
			console.log("loadCategories", selectedEtlImportUuid);

			const [dictionnaryCategories, extractCategories] = await Promise.all([
				extra.etlClient.findAll(DictionaryCategorySchema, { params: { etlImportUuid: selectedEtlImportUuid } }),
				extra.etlClient.findAll(ExtractCategorySchema, { params: { etlImportUuid: selectedEtlImportUuid } }),
			]);

			return {
				dictionnaryCategories,
				extractCategories,
			}
		} catch (error) {
			dispatch(displayApiErrorToast(error));
			return rejectWithValue(error);
		}
	},
	{
		condition: (data, { getState }) => {
			if (data?.forceReload) return true;
			if (!getState().etlData.selectedEtlImportUuid) return false;
			return [LoadingStatusEnum.NotLoaded, LoadingStatusEnum.Error].includes(getState().etlData.categoriesLoadingStatus);
		}
	}
);
